import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "remove",
  "use": "remove-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"remove\"><path fill-rule=\"evenodd\" d=\"M36.95 32l18.738-18.738-4.95-4.95L32 27.05 13.262 8.312l-4.95 4.95L27.05 32 8.312 50.738l4.95 4.95L32 36.95l18.738 18.738 4.95-4.95L36.95 32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol